import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-gmix',
  templateUrl: './gmix.component.html',
  styleUrls: ['./gmix.component.scss']
})
export class GmixComponent implements OnInit {

  constructor(
    private el: ElementRef,

  ) { }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://files.coinmarketcap.com/static/widget/currency.js';
    script.async = true;
    document.body.appendChild(script);
  }
  openSectionBenefits(number: any) {
    if(number == 1){
      const tag = this.el.nativeElement.querySelector('.expansive-gmix');
      const tagBtn = this.el.nativeElement.querySelector('.module-gmix .more');
      tag.classList.toggle('open');
      tagBtn.classList.toggle('active');
      if(tagBtn.classList.contains('active')){
        tag.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  closeSectionBenefits(number: any) {
    if(number == 1){
      const tag = this.el.nativeElement.querySelector('.expansive-gmix');
      const tagBtn = this.el.nativeElement.querySelector('.module-gmix .more');
      tag.classList.remove('open');
      tagBtn.classList.remove('active');
    } else if (number == 2) {
      let tag2 = this.el.nativeElement.querySelector(".expansive-gmix");
      let tagBtn2 = this.el.nativeElement.querySelector(".module-gmix .more");
      tag2.classList.remove('open');
      tagBtn2.classList.remove('active');
      if(tagBtn2.classList.contains('active')){
        tag2.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
}

